import React from 'react';
import './Breadcrumbs.css';

const Breadcrumbs = ({ items, separator = '/', className = '' }) => {
  return (
    <nav className={`breadcrumbs ${className}`} aria-label="Breadcrumb">
      <ol className="breadcrumbs__list">
        {items.map((item, index) => (
          <li key={index} className="breadcrumbs__item">
            {index > 0 && (
              <span className="breadcrumbs__separator">{separator}</span>
            )}
            {item.url ? (
              <a href={item.url} className="breadcrumbs__link">
                {item.label}
              </a>
            ) : (
              <span className="breadcrumbs__current" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;